import api from "../services/api";

// VAPID public keys are URL-safe base64 — the Push API needs a raw Uint8Array.
const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
};

// Registers the service worker and subscribes this browser/device to Web
// Push, so message and task notifications keep arriving with the app tab
// (or the whole browser) closed. No-ops quietly if the browser doesn't
// support it, permission is denied, or the server has no VAPID key set.
export const subscribeToPushNotifications = async () => {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return;
  if (Notification.permission !== "granted") return;

  try {
    const registration = await navigator.serviceWorker.register("/service-worker.js");
    await navigator.serviceWorker.ready;

    let subscription = await registration.pushManager.getSubscription();

    if (!subscription) {
      const { data } = await api.get("/push/vapid-public-key");
      if (!data?.publicKey) return;

      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(data.publicKey)
      });
    }

    await api.post("/push/subscribe", subscription.toJSON());
  } catch (err) {
    // Non-fatal — in-app socket notifications still work regardless.
    console.warn("Push subscription failed:", err?.message || err);
  }
};
